import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var WorkdaySvg = function WorkdaySvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005DB9",
    fillRule: "evenodd",
    d: "M4 11.238c.1-.117.216-.243.382-.23.485-.005.973-.016 1.458.006.247.008.416.23.453.464.477 1.99.946 3.983 1.421 5.974.14.615.31 1.223.4 1.848.094.562.113 1.132.202 1.695.123-.803.232-1.611.444-2.396l1.865-7.127a.575.575 0 0 1 .562-.463c.54-.014 1.082-.005 1.623-.005.29-.014.6.16.67.464.465 1.733.923 3.468 1.386 5.2.28 1.124.648 2.228.807 3.38.044.317.086.635.15.95.174-1.81.629-3.57 1.003-5.343.308-1.41.61-2.821.922-4.231.046-.284.339-.426.596-.418.437-.003.875-.016 1.312.007.259.008.408.302.317.538q-1.314 4.977-2.63 9.955a.57.57 0 0 1-.538.478c-.677.023-1.356.005-2.034.009-.243.016-.5-.118-.542-.38-.607-2.282-1.202-4.567-1.803-6.85-.217-.794-.305-1.617-.397-2.434-.111.727-.167 1.467-.356 2.181q-.924 3.526-1.85 7.054c-.07.38-.494.456-.81.432-.63-.012-1.26.014-1.89-.012-.225 0-.398-.178-.438-.396-.885-3.303-1.766-6.61-2.652-9.913-.03-.144-.026-.291-.033-.437",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA126",
    fillRule: "evenodd",
    d: "M19.043 9a.96.96 0 0 1-.896-.639C17.185 5.74 14.715 3.978 12 3.978c-2.714 0-5.185 1.761-6.147 4.382a.95.95 0 0 1-1.235.574c-.494-.193-.743-.764-.556-1.275C5.305 4.274 8.495 2 12 2s6.696 2.275 7.938 5.66c.187.51-.062 1.082-.556 1.275a.9.9 0 0 1-.34.065",
    clipRule: "evenodd"
  }));
};
export var Workday = function Workday(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: WorkdaySvg
  }));
};